import {
  call, select, put,
} from 'redux-saga/effects';
import actionTypes from 'store/postflop/actionTypes';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import {
  resolvePostflopDataLocation,
} from '../../../utils/postflopPosition';
import {
  getTableSize, getStackSize, getPositionType, getPosition,
  getResultsPositionType,
  getResultsPosition,
  getSelectedBoard,
  getPageMode,
} from '../selectors';
import { setBoardSituation } from '../actions';
import { getRequestRevision, isCurrentRequest, requestMeta } from '../requestState';
import watchRequest from './requestLifecycle';

export function* setPostflopSituationGen({ payload = {} } = {}) {
  const revision = yield select(getRequestRevision('situation'));
  const meta = requestMeta('situation', revision);
  const game = yield select(getTableSize);
  const bb = yield select(getStackSize);
  const positionType = yield select(getPositionType);
  const position = yield select(getPosition);
  const resultsPositionType = yield select(getResultsPositionType);
  const resultsPosition = yield select(getResultsPosition);
  const selectedBoard = yield select(getSelectedBoard);
  const pageMode = yield select(getPageMode);
  const isResultsMode = pageMode?.value === 'Results';
  const requestPositionType = isResultsMode ? resultsPositionType?.value : positionType;
  const requestPosition = isResultsMode ? resultsPosition?.value : position[0];
  // '5s3h2c'

  const isPlo5Request = typeof payload.isPlo5 === 'boolean'
    ? payload.isPlo5
    : sessionStorage.getItem('isPlo5') === 'true';
  const requestBoard = payload.board || selectedBoard;

  const defineEndpoint = () => {
    if (isPlo5Request) return URL.PLO5_POSTFLOP_SITUATION;
    return URL.POSTFLOP_SITUATION;
  };

  const dataLocation = resolvePostflopDataLocation({
    game,
    isPlo5: isPlo5Request,
    bb,
    positionType: requestPositionType,
    spot: requestPosition,
  });

  try {
    const res = yield call(api, {
      method: 'post',
      url: defineEndpoint(),
      data: {
        bb,
        game: dataLocation.game,
        position_type: dataLocation.positionType,
        position: dataLocation.position,
        board: requestBoard,
      },
    });

    if (!(yield select(isCurrentRequest('situation', revision)))) return;
    const data = res?.data;
    if (!Array.isArray(data) || !data.length) throw new Error('No strategy is available for this board and spot.');
    yield put({ ...setBoardSituation.success(data), meta });
    yield put({ type: `${actionTypes.SET_POSTFLOP_SITUATION}_SUCCESS`, meta });
  } catch (e) {
    if (!(yield select(isCurrentRequest('situation', revision)))) return;
    const message = e.message || String(e);
    yield put({ ...setBoardSituation.error(message), meta });
    yield put({ type: `${actionTypes.SET_POSTFLOP_SITUATION}_ERROR`, error: message, meta });
    yield call(toast.error, message);
  }
}

export default function* listener() {
  yield* watchRequest('situation', setPostflopSituationGen);
}
